export const formatUrl = (url: string) => {
  if (url && !url.startsWith('http')) {
    return `https://lykstage.com/upload/uploads/${url}`
  } else return url
}

export function formatSubscriberCount(subscriberCount?: string) {
  if (!subscriberCount) return
  const count = +subscriberCount
  if (count == 0) return '0 subscribers'
  if (count <= 1) {
    return count + ' subscriber'
  }
  if (count < 1000) {
    return count + ' subscribers'
  } else if (count >= 1000 && count < 1000000) {
    return Math.floor(count / 1000) + 'K subscribers'
  } else if (count >= 1000000 && count < 100000000) {
    return Math.floor(count / 1000000) + 'M  subscribers'
  } else {
    return Math.floor(count / 1000000000) + 'B subscribers'
  }
}

export function formatComment(commentCount: string) {
  if (!commentCount) return
  const count = +commentCount
  if (count == 1) {
    return count + ' Comment'
  }
  if (count < 1000) {
    return count + ' Comments'
  } else if (count >= 1000 && count < 1000000) {
    return Math.floor(count / 1000) + 'K Comments'
  } else if (count >= 1000000 && count < 100000000) {
    return Math.floor(count / 1000000) + 'M  Comments'
  } else {
    return Math.floor(count / 1000000000) + 'B Comments'
  }
}

export function formatNumber(subscriberCount: string) {
  if (!subscriberCount) return
  const count = +subscriberCount
  if (count == 1) {
    return count
  }
  if (count < 1000) {
    return count
  } else if (count >= 1000 && count < 1000000) {
    return Math.floor(count / 1000) + 'K '
  } else if (count >= 1000000 && count < 100000000) {
    return Math.floor(count / 1000000) + 'M  '
  } else {
    return Math.floor(count / 1000000000) + 'B '
  }
}

export const formatDuration = (duration: string) => {
  const hours = Math.floor(Number(duration) / 3600)
  const minutes = Math.floor((Number(duration) % 3600) / 60)
  const seconds = Math.floor(Number(duration) % 60)

  if (hours > 0) {
    return `${hours}:${minutes}:${seconds}`
  }

  return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
}

export const formatWatchTime = (watchTime: string) => {
  if (Number(watchTime) < 60) {
    if (Number(watchTime) == 0) {
      return `Less than 1 hour watched by viewers`
    }
    return `${watchTime} seconds watched by viewers`
  }

  const hours = Math.floor(Number(watchTime) / 3600)
  const minutes = Math.floor((Number(watchTime) % 3600) / 60)

  let formattedTime = ''
  if (hours > 0) formattedTime += hours == 1 ? '1 hour ' : `${hours} hours `
  if (minutes > 0)
    formattedTime += minutes == 1 ? '1 minute ' : `${minutes} minutes `
  formattedTime += 'watched by viewers'

  return formattedTime
}

export const formatWatchTimeHours = (watchTime: string) => {
  if (Number(watchTime) < 3600) {
    return 'Less than 1 hour watched'
  }

  return `Over ${Math.floor(Number(watchTime) / 3600)} hour watched`
}
export const formatTimeUpload = (date: string) => {
  const uploadDate = new Date(date.replace(/\s/, 'T'))
  const currentDate = new Date()
  const timeDifference = currentDate.getTime() - uploadDate.getTime()
  const seconds = timeDifference / 1000
  const minutes = seconds / 60
  const hours = minutes / 60
  const days = hours / 24
  const weeks = days / 7
  const months = weeks / 4
  const years = months / 12

  if (seconds < 60) {
    return `Just now`
  }

  if (minutes < 60) {
    return `${Math.floor(minutes)} min ago`
  }

  if (hours < 24) {
    return `${Math.floor(hours)} hr ago`
  }

  if (days < 7) {
    return `${Math.floor(days)} ${Math.floor(days) == 1 ? 'day' : 'days'} ago`
  }

  if (weeks < 4) {
    return `${Math.floor(weeks)} weeks ago`
  }

  if (months < 12) {
    return `${Math.floor(months)} months ago`
  }

  if (months == 12) {
    return `1 year ago`
  }

  return `${Math.floor(years)} years ago`
}

export function formatDate(dateString: string) {
  if (!dateString) {
    return ''
  }
  const date = new Date(dateString.replace(/\s/, 'T'))

  const month = date.getMonth()

  const day = date.getDate()

  const monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ]

  return `${monthNames[month]} ${day}, ${date.getFullYear()}`
}
